module.exports = __webpack_public_path__ + "img/logo_mava_fondation.aba430c2.jpg";